export function buildCommandRegistry(sideBarConfig) {
    const commands = [];
    sideBarConfig.forEach(section => {
        section.navItems
            .filter(item => !item.shouldOpenGetStartedWithTEUrl &&
            !item.shouldOpenIntercom)
            .forEach(item => {
            commands.push({
                id: item.id,
                label: item.label,
                section: section.label,
                searchText: `${section.label} ${item.label}`.toLowerCase(),
                type: 'page',
            });
        });
    });
    return commands;
}
export function filterCommands(commands, query) {
    const q = query.toLowerCase().trim();
    if (!q)
        return commands.filter(cmd => cmd.type === 'page');
    if (q.includes('/')) {
        const [parentQuery, childQuery] = q.split('/').map(s => s.trim());
        const parentTerms = parentQuery.split(/\s+/).filter(Boolean);
        const childTerms = childQuery.split(/\s+/).filter(Boolean);
        const matchingParentIds = new Set(commands
            .filter(cmd => cmd.type === 'page' &&
            parentTerms.every(term => cmd.searchText.includes(term)))
            .map(cmd => cmd.id));
        if (childTerms.length === 0) {
            return commands.filter(cmd => cmd.parentId && matchingParentIds.has(cmd.parentId));
        }
        return commands.filter(cmd => cmd.type === 'section' &&
            cmd.parentId &&
            matchingParentIds.has(cmd.parentId) &&
            childTerms.every(term => cmd.label.toLowerCase().includes(term)));
    }
    const terms = q.split(/\s+/);
    return commands.filter(cmd => terms.every(term => cmd.searchText.includes(term)));
}
//# sourceMappingURL=admin-command-registry.js.map